import { render, staticRenderFns } from "./BaseSimpleCheckbox.vue?vue&type=template&id=1942fdae"
import script from "./BaseSimpleCheckbox.vue?vue&type=script&lang=js"
export * from "./BaseSimpleCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports